import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
/* import mosaic from "../../../assets/landing-cat-mosaic.png"; */
import { UserType } from "../../../data/enums";

interface LandingCATProps {
  redirect: (path: string) => void;
}

function LandingCAT({ redirect }: LandingCATProps) {
  return (
    <div className="landing-cat">
      <div className="landing-cat-info">
        <Typography variant="h2" component="h2" id="landing-cat-h">
          ¿Querés comenzar una vida más sana?
        </Typography>
        <Typography variant="body1" component="p" id="landing-cat-p" className="landing-p">
          Descubrí la información que está en tus genes. Te ayudamos a que
          alcances tu peso saludable, objetivos deportivos y bienestar comenzando
          con una prueba.
        </Typography>
        <Button color="primary" variant="contained" onClick={() => redirect(`/signup?user=${UserType.EndUser}`)} disableElevation>
            Comprar Mr. Gen
        </Button>
      </div>
      <img src="https://res.cloudinary.com/hqs-cdn/image/upload/v1634906803/mistergen/landing-cat-mosaic_qjyak0.png" alt="Mosaico decorativo" />
    </div>
  );
}

export default LandingCAT;